<div class="d-flex py-4 justify-content-between">
  <div class="d-flex">
    <div class="d-flex flex-wrap align-items-center gap-3">
      <base-customer-employee-short-info
        [currentAssignment]="customerAssignment"
        [avgRating]="updatedAvgRating"
        [ratingAmount]="updatedRatingsAmount"
      ></base-customer-employee-short-info>

      <ng-container
        *ngIf="customerAssignment && !!customerAssignment.contracts?.length && !!customerAssignment.contractFileName"
      >
        <base-sign-contract-animated-status-button
          *ngIf="
            validContract &&
              validContract.type === contractSigningType.DIGITAL &&
              (validContract.signatures?.statusCustomer === signingStatusBySide.in_queue ||
                validContract.signatures?.statusCustomer === signingStatusBySide.error ||
                validContract.signatures?.statusPsp === signingStatusBySide.error);
            else standardButton
          "
          [contract]="validContract"
          (click)="showSignContractsModal($event)"
        ></base-sign-contract-animated-status-button>

        <ng-template #standardButton>
          <base-button
            [size]="buttonSizes.md"
            [iconSize]="buttonSizes.md"
            [stateClass]="statusButtonBorder"
            [permissionBased]="true"
            [ngbTooltip]="signStatusTooltip"
            color="dark"
            icon="fa-solid fa-file-signature"
            (btnClick)="showSignContractsModal($event)"
          ></base-button>
        </ng-template>
      </ng-container>
      <ng-container
        *ngIf="
          !customerAssignment?.assignmentCancelation && assignmentStatus !== intervalStatus.ended && !deregistered;
          else cancelledInfo
        "
      >
        <base-button
          [size]="buttonSizes.md"
          color="secondary"
          label="externalEmployees.unsubscribe"
          (btnClick)="openCandidateDeregisterModal()"
        ></base-button>
      </ng-container>
      <ng-template #cancelledInfo>
        <span
          *ngIf="customerAssignment?.assignmentCancelation?.cancelationDate as cancelationDate"
          class="fw-bold text-danger"
        >
          {{ 'operations.cancelledOn' | translate }}
          {{ cancelationDate | baseFormatDate }}
        </span>
      </ng-template>
      <base-button
        color="primary"
        [size]="buttonSizes.md"
        [disabled]="!customerAssignment?.inquiryId"
        [label]="
          assignmentStatus === intervalStatus.ended
            ? 'externalEmployees.inquireEmployee'
            : 'externalEmployees.extendAssignment'
        "
        [ngbTooltip]="'externalEmployees.disableInquiryEmployeeBtnTooltip' | translate"
        [disableTooltip]="!!customerAssignment?.inquiryId"
        (btnClick)="openInquireEmployeeModal()"
      ></base-button>
    </div>
  </div>
  <i
    class="fa-solid fa-circle-xmark pointer fa-2x"
    (click)="closeModal()"
  ></i>
</div>
<base-horizontal-nav
  class="m-3"
  [tabs]="tabs"
  [current]="currentTab"
  (tabChange)="onTabChange($event)"
></base-horizontal-nav>
<div class="overflow-modal-content">
  <div class="modal-tab-content h-100">
    <base-customer-employee-master-data-tab
      *ngIf="customerOfferTabsEnum.MaterData === currentTab.id && customerAssignment"
      [assignment]="customerAssignment"
    ></base-customer-employee-master-data-tab>
    <base-customer-employee-operation-info-tab
      *ngIf="customerOfferTabsEnum.AssignmentInformation === currentTab.id"
      (signContract)="showSignContractsModal($event)"
      (deregisterEmployee)="openCandidateDeregisterModal()"
      (inquireEmployee)="openInquireEmployeeModal()"
    ></base-customer-employee-operation-info-tab>
    <base-customer-employee-reviews-tab
      *ngIf="customerOfferTabsEnum.Reviews === currentTab.id && customerAssignment"
      [assignment]="customerAssignment"
      [isOfferConfirmed]="true"
    ></base-customer-employee-reviews-tab>
    <base-customer-employee-documents-tab
      *ngIf="customerOfferTabsEnum.Documents === currentTab.id"
      [assignment]="customerAssignment"
    ></base-customer-employee-documents-tab>
    <base-customer-employee-time-recordings-tab
      *ngIf="customerOfferTabsEnum.TimeRecordings === currentTab.id && customerAssignment"
      [assignment]="customerAssignment"
    ></base-customer-employee-time-recordings-tab>
    <ng-container *ngIf="customerAssignment && showWorkCouncilTab && customerAssignment.offerId">
      <base-customer-employee-work-council-tab
        *ngIf="customerOfferTabsEnum.WorkCouncil === currentTab.id"
        [offerId]="customerAssignment.offerId"
        [assignmentId]="customerAssignment.id"
        [profileFullName]="customerAssignment.profile.firstName + ' ' + customerAssignment.profile.lastName"
        [workCouncilStatus]="customerAssignment.workCouncilStatus"
      ></base-customer-employee-work-council-tab>
    </ng-container>
  </div>
</div>

<ng-template #signStatusTooltip>
  <base-sign-contract-status-tooltip
    [contract]="validContract"
    [isPsp]="false"
  ></base-sign-contract-status-tooltip>
</ng-template>

<ng-template #deregisterModalRef>
  <base-deregister-candidate-modal
    [form]="deregisterForm"
    [assignment]="customerAssignment"
    [isFormSubmitted]="deregisterFormSubmitted"
  ></base-deregister-candidate-modal>
</ng-template>

<ng-template #addSignSelectionPopup>
  <base-sign-contract-selection
    [modalRef]="addSignModalRef"
    [(signingType)]="signingType"
    [currentAssignment]="customerAssignment"
    (signingTypeChange)="onSignTypeChange($event)"
  ></base-sign-contract-selection>
</ng-template>

<ng-template #addSignPopup>
  <base-sign-contracts-sign
    [modalRef]="digitalSignModalRef"
    [reloadAssignmentAfterSigning]="true"
  ></base-sign-contracts-sign>
</ng-template>

<ng-template #inquireEmployeeModal>
  <base-customer-staff-request-modal
    [isInquireSpecificEmployee]="true"
    [isInquiryDefaultFilter]="true"
    [assignment]="customerAssignment"
    [inquiry]="inquiry"
    [modalRef]="inquireEmployeeModalModalRef"
  ></base-customer-staff-request-modal>
</ng-template>
